// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"8627a1e92e85fe985f1c","883":"6796ce7ec007181f7e78"}[chunkId] + ".js";
};